import type * as Types from 'app/types/graphql';

export type ClickTypeCountSelectFragment = Pick<Types.ClickTypeCount, 'type' | 'totalCount'>;

export type ChannelStatsSelectFragment = Pick<Types.ChannelStats, 'type' | 'totalCount'>;

export type HeatmapVisitorStatsSelectFragment = Pick<
  Types.HeatmapVisitorStats,
  'type' | 'totalCount'
>;

export type DeviceTypeCountSelectFragment = Pick<
  Types.DeviceTypeCount,
  | 'deviceType'
  | 'totalClicks'
  | 'totalSessions'
  | 'totalVisitors'
  | 'totalRevenue'
  | 'totalPageViewed'
  | 'totalPageViewedHaveTimeOnPage'
  | 'totalTimeOnPage'
  | 'avgScrollDepth'
  | 'engagedSessions'
  | 'totalSessionsThatCompletedCheckout'
> & {
  clickTypes: Array<Pick<Types.ClickTypeCount, 'type' | 'totalCount'>>;
  channels?: Types.Maybe<Array<Types.Maybe<Pick<Types.ChannelStats, 'type' | 'totalCount'>>>>;
  visitors?: Types.Maybe<
    Array<Types.Maybe<Pick<Types.HeatmapVisitorStats, 'type' | 'totalCount'>>>
  >;
};

export const ClickTypeCountSelectFragmentDoc = `
    fragment ClickTypeCountSelect on ClickTypeCount {
  type
  totalCount
}
    `;
export const ChannelStatsSelectFragmentDoc = `
    fragment ChannelStatsSelect on ChannelStats {
  type
  totalCount
}
    `;
export const HeatmapVisitorStatsSelectFragmentDoc = `
    fragment HeatmapVisitorStatsSelect on HeatmapVisitorStats {
  type
  totalCount
}
    `;
export const DeviceTypeCountSelectFragmentDoc = `
    fragment DeviceTypeCountSelect on DeviceTypeCount {
  deviceType
  totalClicks
  totalSessions
  totalVisitors
  totalRevenue
  totalPageViewed
  totalPageViewedHaveTimeOnPage
  totalTimeOnPage
  avgScrollDepth
  engagedSessions
  totalSessionsThatCompletedCheckout
  clickTypes {
    ...ClickTypeCountSelect
  }
  channels {
    ...ChannelStatsSelect
  }
  visitors {
    ...HeatmapVisitorStatsSelect
  }
}
    `;
